module.exports = __webpack_public_path__ + "static/media/marketing-about-mb.60712059.png";